import React from 'react';
import { Modal } from './ui/Modal';
interface Props {
  isOpen: boolean;
  onClose: () => void;
}
export function TermsModal({
  isOpen,
  onClose
}: Props) {
  return <Modal isOpen={isOpen} onClose={onClose} title="Términos y Condiciones" data-id="element-192">
      <div className="space-y-4" data-id="element-193">
        <p data-id="element-194">
          <strong data-id="element-195">1. Aceptación de los Términos</strong>
          <br data-id="element-196" />
          Al acceder y utilizar este producto digital, usted acepta estar sujeto
          a estos Términos y Condiciones. Si no está de acuerdo con alguna parte
          de los términos, no podrá acceder al servicio.
        </p>

        <p data-id="element-197">
          <strong data-id="element-198">2. Producto Digital</strong>
          <br data-id="element-199" />
          "Drenaje Brasileño en Casa" es un producto de información digital. No
          se enviará ningún producto físico. El acceso se proporciona
          inmediatamente después de la confirmación del pago.
        </p>

        <p data-id="element-200">
          <strong data-id="element-201">3. Descargo de Responsabilidad Médica</strong>
          <br data-id="element-202" />
          La información proporcionada en esta guía tiene fines educativos y no
          sustituye el consejo médico profesional. Consulte siempre a su médico
          antes de comenzar cualquier nueva práctica de salud, especialmente si
          tiene condiciones médicas preexistentes.
        </p>

        <p data-id="element-203">
          <strong data-id="element-204">4. Propiedad Intelectual</strong>
          <br data-id="element-205" />
          Todo el contenido incluido en este producto digital está protegido por
          derechos de autor. No está permitida la reproducción, distribución o
          reventa no autorizada del material.
        </p>

        <p data-id="element-206">
          <strong data-id="element-207">5. Política de Reembolso</strong>
          <br data-id="element-208" />
          Debido a la naturaleza digital del producto, las políticas de
          reembolso se rigen por los términos de la plataforma de pago
          (Hotmart). Consulte sus políticas específicas al momento de la compra.
        </p>
      </div>
    </Modal>;
}